// src/components/layouts/renderers/NewsPostFrame.tsx
import React from 'react';
import type { LayoutRendererProps, NewsPostConfig } from '@/lib/layouts/types';
import {
  toBreakingNewsConfig, toChoqueiConfig, toInstagramConfig, toNewspaperConfig,
} from '@/lib/layouts/newsPostMapping';
import { ChoqueiFrame } from './ChoqueiFrame';
import { BreakingNewsFrame } from './BreakingNewsFrame';
import { NewspaperFrame } from './NewspaperFrame';
import { InstagramNewsFrame } from './InstagramNewsFrame';

/**
 * Unified "News Post" layout: one picker entry, four chrome styles. Rendering
 * delegates to the legacy frames so previously shipped visuals stay identical.
 */
export const NewsPostFrame: React.FC<LayoutRendererProps<NewsPostConfig>> = ({ config, media }) => {
  switch (config.style) {
    case 'breaking_news':
      return <BreakingNewsFrame config={toBreakingNewsConfig(config)} media={media} />;
    case 'newspaper':
      return <NewspaperFrame config={toNewspaperConfig(config)} media={media} />;
    case 'instagram':
      return <InstagramNewsFrame config={toInstagramConfig(config)} media={media} />;
    case 'choquei':
    default:
      return <ChoqueiFrame config={toChoqueiConfig(config)} media={media} />;
  }
};
